import React, { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  MenuItem, Select, InputLabel, FormControl,
  FormControlLabel, Checkbox,
  Typography
} from "@mui/material";

const ScheduleDialog = ({ open, onClose, userId, onSave, initialDate  }) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [datetime, setDatetime] = useState("");
  const [duration, setDuration] = useState(60); // 기본: 1시간
  const [alarmEnabled, setAlarmEnabled] = useState(false);
  const [alarmOffset, setAlarmOffset] = useState(10); // 기본 10분 전 알림
  const [color, setColor] = useState("#3f51b5"); // 기본 색상

 // 🔄 다이얼로그 열릴 때 초기화 및 날짜 설정
  useEffect(() => {
    if (open) {
      setTitle("");
      setDescription("");
      setDuration(60);
      setAlarmEnabled(false);
      setAlarmOffset(10);

      if (initialDate) {
        const localISO = new Date(initialDate).toISOString().slice(0, 16); // "yyyy-MM-ddTHH:mm"
        setDatetime(localISO);
      } else {
        setDatetime("");
      }
    }
  }, [open, initialDate]);

  const handleSave = async () => {
    if (!title || !datetime || !userId) return;

    const start = new Date(datetime); // ✅ Date 객체
    const end = new Date(start.getTime() + duration * 60 * 1000);
    const alarmTime = alarmEnabled
      ? new Date(start.getTime() - alarmOffset * 60 * 1000)
      : null;

    // 삽입 시에는 toISOString으로 변환
    const { error } = await supabase.from("reservations").insert({
      user_id: userId,
      title,
      description,
      start_time: start.toISOString(),
      end_time: end.toISOString(),
      alarm_time: alarmTime ? alarmTime.toISOString() : null,
      color
    });

    if (error) {
      alert("예약 저장 실패: " + error.message);
      return;
    }

    if (onSave) onSave(); // 캘린더 갱신 트리거
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>예약 일정 추가</DialogTitle>
      <DialogContent dividers sx={{ pt: 1 }}>
        <Box sx={{pt:1}}></Box>
       
        <Box sx={{display:"flex",flexDirection:"row",alignItems:"center",pb:1}}>
          <Typography>색상선택 </Typography>
          <input
            type="color"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            style={{ width: "50px", height: "30px", border: "none", background: "transparent"}}
          />
        </Box>

        <TextField
          label="일정 제목"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          fullWidth
          sx={{ mb: 2}}
        />
        <TextField
          label="날짜 및 시간 선택"
          type="datetime-local"
          value={datetime}
          onChange={(e) => setDatetime(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
        />
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>이용시간</InputLabel>
          <Select
            label="이용시간"
            value={duration}
            onChange={(e) => setDuration(parseInt(e.target.value))}
          >
            <MenuItem value={30}>30분</MenuItem>
            <MenuItem value={60}>1시간</MenuItem>
            <MenuItem value={90}>1시간 30분</MenuItem>
            <MenuItem value={120}>2시간</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="일정 내용"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={alarmEnabled}
              onChange={(e) => setAlarmEnabled(e.target.checked)}
            />
          }
          label="알림 받기"
          sx={{ mb: 1 }}
        />
        {alarmEnabled && (
          <FormControl fullWidth>
            <InputLabel>알림 시간</InputLabel>
            <Select
              value={alarmOffset}
              onChange={(e) => setAlarmOffset(parseInt(e.target.value))}
              label="알림 시간"
            >
              <MenuItem value={5}>5분 전</MenuItem>
              <MenuItem value={10}>10분 전</MenuItem>
              <MenuItem value={30}>30분 전</MenuItem>
              <MenuItem value={60}>1시간 전</MenuItem>
            </Select>
          </FormControl>
        )}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button onClick={handleSave} variant="contained">저장</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleDialog;
